import React from 'react';

function ClientSidebarHeader({
  t,
  selectedProfile,
  onShowClientInfo,
  onOarsInfoOpen,
  onStrategyInfoOpen,
  onShowCounsellors,
}) {
  return (
    <div className="sidebar-header">
      <div className="sidebar-title">
        <h3>{selectedProfile === -4 ? 'TRAIN A STRATEGY' : selectedProfile === -3 ? t('sidebar_heading_context') : selectedProfile === -2 ? 'Virtual Counsellor' : t('sidebar_heading_clients')}</h3>
        {selectedProfile === -4 && (
          <button
            type="button"
            className="sidebar-info-btn"
            onClick={() => onStrategyInfoOpen?.()}
            aria-label="Specific Strategies information"
            title="Specific Strategies information"
          >
            i
          </button>
        )}
        {selectedProfile !== -4 && selectedProfile !== -3 && selectedProfile !== -2 && (
          <button
            type="button"
            className="sidebar-info-btn"
            onClick={() => onShowClientInfo && onShowClientInfo()}
            aria-label={t('sidebar_roster_info_label')}
            title={t('sidebar_roster_info_label')}
          >
            i
          </button>
        )}
        {selectedProfile === -3 && (
          <button
            type="button"
            className="sidebar-info-btn"
            onClick={() => onOarsInfoOpen && onOarsInfoOpen('overview')}
            aria-label="OARS mode instructions"
          >
            i
          </button>
        )}
        {selectedProfile === -2 && (
          <button
            type="button"
            className="sidebar-info-btn"
            onClick={() => onShowCounsellors && onShowCounsellors()}
            aria-label={t('report_menu_counsellors')}
            title={t('report_menu_counsellors')}
          >
            i
          </button>
        )}
      </div>

    </div>
  );
}

export default ClientSidebarHeader;
